import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Grid,
  TextField,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  CircularProgress,
  Avatar,
  Paper,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { useFormik } from "formik";
import * as Yup from "yup";
import StudentService from "./Locality/Service/studentService";

const BRAND = "#0f3b62";

const useStyles = makeStyles((theme) => ({
  page: {
    maxWidth: 960,
    margin: "0 auto",
    padding: theme.spacing(3),
    backgroundColor: "#f8fafc",
    minHeight: "calc(100vh - 80px)",
  },
  hero: {
    background: `linear-gradient(135deg, ${BRAND} 0%, #1a5a8a 100%)`,
    borderRadius: 16,
    padding: theme.spacing(3, 3.5),
    color: "#fff",
    marginBottom: theme.spacing(3),
    boxShadow: "0 8px 24px rgba(15, 59, 98, 0.18)",
  },
  heroTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: 6,
  },
  heroSubtitle: {
    fontSize: "0.9rem",
    opacity: 0.92,
    lineHeight: 1.5,
  },
  sectionCard: {
    backgroundColor: "#fff",
    borderRadius: 14,
    border: "1px solid #e2e8f0",
    padding: theme.spacing(2.5, 3),
    marginBottom: theme.spacing(2.5),
    boxShadow: "0 2px 8px rgba(15, 59, 98, 0.04)",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: theme.spacing(2),
    color: BRAND,
  },
  sectionTitle: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#0f2d4d",
  },
  sectionHint: {
    fontSize: "0.8rem",
    color: "#64748b",
    marginBottom: theme.spacing(2),
  },
  uploadRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 12,
    padding: theme.spacing(1.5, 2),
    borderRadius: 10,
    border: "1px dashed #cbd5e1",
    backgroundColor: "#f8fafc",
  },
  profileAvatar: {
    width: 112,
    height: 112,
    border: "3px solid #e2e8f0",
    fontSize: "2.5rem",
    backgroundColor: "#eef4ff",
    color: BRAND,
  },
  pickupCard: {
    padding: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    backgroundColor: "#fafbfc",
    marginBottom: theme.spacing(1.5),
  },
  thumb: {
    width: 96,
    height: 96,
    objectFit: "cover",
    borderRadius: 10,
    border: "1px solid #e2e8f0",
  },
  primaryBtn: {
    backgroundColor: BRAND,
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "8px 20px",
    "&:hover": { backgroundColor: "#0a2d4a" },
  },
  secondaryBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    color: "#46566b",
    borderColor: "#d1d9e6",
  },
  iconBtnAdd: {
    minWidth: 40,
    backgroundColor: BRAND,
    color: "#fff",
    "&:hover": { backgroundColor: "#0a2d4a" },
  },
  iconBtnRemove: {
    minWidth: 40,
    backgroundColor: "#94a3b8",
    color: "#fff",
    "&:hover": { backgroundColor: "#64748b" },
  },
  actionsBar: {
    display: "flex",
    gap: 12,
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  loadingWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 360,
  },
}));

const getImageListArray = (list) => {
  if (Array.isArray(list)) return list.map((u) => String(u || "").trim()).filter(Boolean);
  if (typeof list === "string" && list.trim()) return [list.trim()];
  return [];
};

function SectionCard({ icon, title, hint, children, classes }) {
  return (
    <Paper className={classes.sectionCard} elevation={0}>
      <div className={classes.sectionHeader}>
        {icon}
        <Typography className={classes.sectionTitle}>{title}</Typography>
      </div>
      {hint ? <Typography className={classes.sectionHint}>{hint}</Typography> : null}
      {children}
    </Paper>
  );
}

function FileUploadRow({ inputId, accept, onChange, onUpload, uploadLabel = "Upload", error, classes }) {
  return (
    <Box>
      <div className={classes.uploadRow}>
        <CloudUploadOutlinedIcon style={{ color: BRAND, fontSize: 28 }} />
        <input id={inputId} type="file" accept={accept} onChange={onChange} style={{ maxWidth: 220 }} />
        <Button variant="contained" className={classes.primaryBtn} onClick={onUpload}>
          {uploadLabel}
        </Button>
      </div>
      {error ? (
        <Typography variant="caption" color="error" style={{ display: "block", marginTop: 6 }}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}

export default function ParentStudentProfile(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [imageslist, setImagesList] = useState([]);
  const [imageslist1, setImagesList1] = useState("");
  const [birthCertificateUrl, setBirthCertificateUrl] = useState("");
  const [images, setImages] = useState("");
  const [images1, setImages1] = useState("");
  const [birthCertificateFile, setBirthCertificateFile] = useState("");
  const [message, setMessage] = useState("");
  const [message1, setMessage1] = useState("");
  const [birthCertificateMessage, setBirthCertificateMessage] = useState("");
  const [hasAllergies, setHasAllergies] = useState("no");
  const [allergyItems, setAllergyItems] = useState([""]);
  const [authorizedPickupItems, setAuthorizedPickupItems] = useState([
    { name: "", mobileNumber: "", photoURL: "" },
  ]);
  const [authorizedPickupFilesByIndex, setAuthorizedPickupFilesByIndex] = useState({});
  const [saving, setSaving] = useState(false);
  const [formValues, setFormValues] = useState({ adharNo: "", address: "", specialNeeds: "" });

  const validationSchema = Yup.object().shape({
    adharNo: Yup.string()
      .test("digits", "Must be only digits", (v) => !v || /^[0-9]+$/.test(String(v)))
      .test("len", "Must be exactly 12 digits", (v) => !v || String(v).length === 12),
    address: Yup.string(),
    specialNeeds: Yup.string(),
  });

  const formik = useFormik({
    initialValues: formValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      if (!studentId) {
        alert("Student not linked to your account.");
        return;
      }
      const payload = {
        profileURL: imageslist1 || "",
        imageURL: getImageListArray(imageslist),
        birthCertificateURL: birthCertificateUrl || "",
        address: values.address || "",
        specialNeeds: values.specialNeeds || "",
        adharNo: values.adharNo || "",
        aadharNo: values.adharNo || "",
        allergies:
          hasAllergies === "yes"
            ? allergyItems.map((s) => String(s).trim()).filter(Boolean).join(", ")
            : "no",
        authorizedPickups: (authorizedPickupItems || [])
          .map((p) => ({
            name: p?.name ? String(p.name).trim() : "",
            mobileNumber: p?.mobileNumber ? String(p.mobileNumber).trim() : "",
            photoURL: p?.photoURL ? String(p.photoURL).trim() : "",
          }))
          .filter((p) => p.name || p.mobileNumber || p.photoURL),
        parentProfilePending: false,
      };
      setSaving(true);
      try {
        await StudentService.updateParentStudentProfile(studentId, payload);
        alert(isEditMode ? "Profile updated successfully." : "Student profile saved successfully.");
        props.history.push("/app/assignment");
      } catch (err) {
        alert(err?.response?.data?.message || err.message || "Failed to save profile.");
      } finally {
        setSaving(false);
      }
    },
  });

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const sid = userDetails?.studentId?._id || userDetails?.studentId;
    if (!sid) {
      setLoading(false);
      return;
    }
    setStudentId(String(sid));
    StudentService.getByIdStudent(sid)
      .then((res) => {
        const s = res?.data || res;
        const full = `${s?.firstName || ""} ${s?.lastName || ""}`.trim();
        setStudentName(full || "Student");
        setIsEditMode(!Boolean(s?.parentProfilePending));
        setImagesList(s?.imageURL || []);
        setImagesList1(s?.profileURL || "");
        setBirthCertificateUrl(s?.birthCertificateURL || "");
        const allergies = s?.allergies ? String(s.allergies).trim() : "";
        if (allergies && allergies.toLowerCase() !== "no") {
          setHasAllergies("yes");
          setAllergyItems(
            allergies.split(",").map((a) => a.trim()).filter(Boolean).length
              ? allergies.split(",").map((a) => a.trim()).filter(Boolean)
              : [""]
          );
        } else {
          setHasAllergies("no");
          setAllergyItems([""]);
        }
        const ap = Array.isArray(s?.authorizedPickups) ? s.authorizedPickups : [];
        if (ap.length) {
          setAuthorizedPickupItems(
            ap.map((p) => ({
              name: p?.name ? String(p.name) : "",
              mobileNumber: p?.mobileNumber ? String(p.mobileNumber) : "",
              photoURL: p?.photoURL ? String(p.photoURL) : "",
            }))
          );
        } else if (s?.authorizedPickupName || s?.authorizedPickupMobileNumber) {
          setAuthorizedPickupItems([
            {
              name: s?.authorizedPickupName ? String(s.authorizedPickupName) : "",
              mobileNumber: s?.authorizedPickupMobileNumber ? String(s.authorizedPickupMobileNumber) : "",
              photoURL: "",
            },
          ]);
        }
        setFormValues({
          adharNo: s?.adharNo || s?.aadharNo || "",
          address: s?.address || "",
          specialNeeds: s?.specialNeeds || "",
        });
      })
      .catch((err) => {
        alert(err?.response?.data?.message || err.message || "Failed to load student profile.");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleFileChange = (e) => setImages(e.target.files);
  const handleFileChange1 = (e) => setImages1(e.target.files);
  const handleBirthCertificateFileChange = (e) => setBirthCertificateFile(e.target.files);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!images || images.length === 0) {
      setMessage("Please select an image first.");
      return;
    }
    const formData = new FormData();
    formData.append("image", images[0]);
    formData.append("imageName", images[0].name);
    try {
      const res = await StudentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) {
        alert("Upload succeeded but no image URL returned.");
        return;
      }
      setImagesList((prev) => [...getImageListArray(prev), url]);
      setMessage("");
    } catch (err) {
      alert(err?.response?.data?.message || err.message || "Upload failed");
    }
  };

  const handleUpload1 = async (e) => {
    e.preventDefault();
    if (!images1 || images1.length === 0) {
      setMessage1("Please select a photo first.");
      return;
    }
    const formData = new FormData();
    formData.append("image", images1[0]);
    formData.append("imageName", images1[0].name);
    try {
      const res = await StudentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) {
        alert("Upload succeeded but no image URL returned.");
        return;
      }
      setImagesList1(url);
      setMessage1("");
    } catch (err) {
      alert(err?.response?.data?.message || err.message || "Upload failed");
    }
  };

  const handleBirthCertificateUpload = async (e) => {
    e.preventDefault();
    if (!birthCertificateFile || birthCertificateFile.length === 0) {
      setBirthCertificateMessage("Please select a file first.");
      return;
    }
    const formData = new FormData();
    formData.append("image", birthCertificateFile[0]);
    formData.append("imageName", birthCertificateFile[0].name);
    try {
      const res = await StudentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) {
        alert("Upload succeeded but no image URL returned.");
        return;
      }
      setBirthCertificateUrl(url);
      setBirthCertificateMessage("");
    } catch (err) {
      alert(err?.response?.data?.message || err.message || "Upload failed");
    }
  };

  const removeGalleryImage = async (index) => {
    const urls = getImageListArray(imageslist);
    const url = urls[index];
    if (url && /^https?:\/\//i.test(url)) {
      try {
        await StudentService.deleteAzureImage({ imageURL: url });
      } catch (err) {
        console.error("Failed to delete image:", err);
      }
    }
    setImagesList(urls.filter((_, i) => i !== index));
    setMessage("");
  };

  const addAllergyItem = () => setAllergyItems((prev) => [...prev, ""]);
  const removeAllergyItem = (index) => {
    setAllergyItems((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length ? next : [""];
    });
  };
  const updateAllergyItem = (index, value) => {
    setAllergyItems((prev) => prev.map((v, i) => (i === index ? value : v)));
  };

  const addAuthorizedPickupItem = () => {
    setAuthorizedPickupItems((prev) => [...prev, { name: "", mobileNumber: "", photoURL: "" }]);
  };
  const removeAuthorizedPickupItem = (index) => {
    setAuthorizedPickupItems((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length ? next : [{ name: "", mobileNumber: "", photoURL: "" }];
    });
  };
  const updateAuthorizedPickupItem = (index, patch) => {
    setAuthorizedPickupItems((prev) =>
      prev.map((v, i) => (i === index ? { ...v, ...(patch || {}) } : v))
    );
  };
  const handleAuthorizedPickupFileChange = (index, e) => {
    setAuthorizedPickupFilesByIndex((prev) => ({ ...(prev || {}), [index]: e?.target?.files }));
  };
  const handleAuthorizedPickupPhotoUpload = async (index, e) => {
    e.preventDefault();
    const files = authorizedPickupFilesByIndex?.[index];
    if (!files || files.length === 0) {
      alert("Please select an image first.");
      return;
    }
    const formData = new FormData();
    formData.append("image", files[0]);
    formData.append("imageName", files[0].name);
    try {
      const res = await StudentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) {
        alert("Upload succeeded but no image URL returned.");
        return;
      }
      updateAuthorizedPickupItem(index, { photoURL: url });
    } catch (err) {
      alert(err?.message || "Failed to upload photo");
    }
  };

  if (loading) {
    return (
      <div className={classes.loadingWrap}>
        <CircularProgress style={{ color: BRAND }} />
      </div>
    );
  }

  const pageTitle = isEditMode ? "Edit Profile" : "Add Profile";
  const pageSubtitle = isEditMode
    ? `Update ${studentName}'s details. Changes will be reflected in the school Student Details page.`
    : `Complete ${studentName}'s profile. The school will see these details after you save.`;

  return (
    <div className={classes.page}>
      <div className={classes.hero}>
        <Typography className={classes.heroTitle}>
          {pageTitle} — {studentName}
        </Typography>
        <Typography className={classes.heroSubtitle}>{pageSubtitle}</Typography>
      </div>

      <SectionCard
        classes={classes}
        icon={<PersonOutlineIcon style={{ color: BRAND }} />}
        title="Profile Photo"
        hint="Upload a clear photo of your child."
      >
        <Box display="flex" flexWrap="wrap" alignItems="center" style={{ gap: 20 }}>
          <Avatar src={imageslist1 || undefined} className={classes.profileAvatar}>
            {(studentName || "?").charAt(0).toUpperCase()}
          </Avatar>
          <Box flex={1} minWidth={240}>
            <FileUploadRow
              classes={classes}
              inputId="parent-profile-photo"
              accept="image/*"
              onChange={handleFileChange1}
              onUpload={handleUpload1}
              uploadLabel="Upload Photo"
              error={message1}
            />
          </Box>
        </Box>
      </SectionCard>

      <SectionCard
        classes={classes}
        icon={<ContactPhoneIcon style={{ color: BRAND }} />}
        title="Authorized Pickup"
        hint="People allowed to pick up your child (optional)."
      >
        {(authorizedPickupItems || []).map((p, idx) => (
          <div key={idx} className={classes.pickupCard}>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={`Pickup Name ${idx + 1}`}
                  variant="outlined"
                  value={p?.name || ""}
                  onChange={(e) => updateAuthorizedPickupItem(idx, { name: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Mobile Number"
                  variant="outlined"
                  value={p?.mobileNumber || ""}
                  onChange={(e) => updateAuthorizedPickupItem(idx, { mobileNumber: e.target.value })}
                />
              </Grid>
              <Grid item xs={12}>
                <div className={classes.uploadRow}>
                  <input type="file" accept="image/*" onChange={(e) => handleAuthorizedPickupFileChange(idx, e)} />
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.primaryBtn}
                    onClick={(e) => handleAuthorizedPickupPhotoUpload(idx, e)}
                  >
                    Upload ID Photo
                  </Button>
                </div>
                {p?.photoURL ? (
                  <Box mt={1.5}>
                    <img src={p.photoURL} alt={`Pickup ${idx + 1}`} className={classes.thumb} />
                  </Box>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" style={{ gap: 8 }}>
                  <Button variant="contained" size="small" className={classes.iconBtnAdd} onClick={addAuthorizedPickupItem}>
                    <AddIcon fontSize="small" />
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.iconBtnRemove}
                    onClick={() => removeAuthorizedPickupItem(idx)}
                    disabled={authorizedPickupItems.length === 1}
                  >
                    <RemoveIcon fontSize="small" />
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </div>
        ))}
      </SectionCard>

      <SectionCard
        classes={classes}
        icon={<HomeOutlinedIcon style={{ color: BRAND }} />}
        title="Personal Details"
        hint="Aadhaar, address, and any special needs."
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="adharNo"
              name="adharNo"
              label="Aadhaar Number"
              variant="outlined"
              size="small"
              value={formik.values.adharNo}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.adharNo && Boolean(formik.errors.adharNo)}
              helperText={formik.touched.adharNo && formik.errors.adharNo}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="address"
              name="address"
              label="Address"
              variant="outlined"
              size="small"
              value={formik.values.address}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="specialNeeds"
              name="specialNeeds"
              label="Special Needs (Optional)"
              variant="outlined"
              size="small"
              multiline
              minRows={3}
              value={formik.values.specialNeeds}
              onChange={formik.handleChange}
            />
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard
        classes={classes}
        icon={<DescriptionOutlinedIcon style={{ color: BRAND }} />}
        title="Documents"
        hint="Upload masked Aadhaar card and birth certificate (optional)."
      >
        <Typography variant="subtitle2" style={{ color: "#0f2d4d", marginBottom: 8, fontWeight: 600 }}>
          Masked Aadhaar Card
        </Typography>
        <FileUploadRow
          classes={classes}
          inputId="parent-aadhar-upload"
          accept="image/*"
          onChange={handleFileChange}
          onUpload={handleUpload}
          error={message}
        />
        {getImageListArray(imageslist).length > 0 ? (
          <Box mt={2} display="flex" flexWrap="wrap" style={{ gap: 12 }}>
            {getImageListArray(imageslist).map((url, index) => (
              <Box key={`aadhar-${index}`} style={{ position: "relative" }}>
                <img src={url} alt={`Aadhaar ${index + 1}`} className={classes.thumb} />
                <IconButton
                  size="small"
                  onClick={() => removeGalleryImage(index)}
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    backgroundColor: "rgba(255,255,255,0.95)",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        ) : null}

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="subtitle2" style={{ color: "#0f2d4d", marginBottom: 8, fontWeight: 600 }}>
          Birth Certificate (Optional)
        </Typography>
        <FileUploadRow
          classes={classes}
          inputId="parent-birth-cert"
          accept="image/*,application/pdf"
          onChange={handleBirthCertificateFileChange}
          onUpload={handleBirthCertificateUpload}
          error={birthCertificateMessage}
        />
        {birthCertificateUrl ? (
          <Box mt={2}>
            {/\.(png|jpe?g|gif|webp)(\?|$)/i.test(birthCertificateUrl) ? (
              <img src={birthCertificateUrl} alt="Birth certificate" className={classes.thumb} />
            ) : (
              <a href={birthCertificateUrl} target="_blank" rel="noreferrer" style={{ color: BRAND, fontWeight: 600 }}>
                View birth certificate
              </a>
            )}
          </Box>
        ) : null}
      </SectionCard>

      <SectionCard classes={classes} title="Allergies" hint="Let the school know about any allergies.">
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend" style={{ color: "#46566b", fontSize: "0.875rem" }}>
            Does your child have allergies?
          </FormLabel>
          <RadioGroup
            row
            name="hasAllergies"
            value={hasAllergies}
            onChange={(e) => {
              const val = e.target.value;
              setHasAllergies(val);
              if (val === "no") setAllergyItems([""]);
            }}
          >
            <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
            <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
          </RadioGroup>
          {hasAllergies === "yes" ? (
            <Box mt={1}>
              {allergyItems.map((item, idx) => (
                <Box key={idx} display="flex" alignItems="center" mb={1} style={{ gap: 8 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Allergy ${idx + 1}`}
                    variant="outlined"
                    value={item}
                    onChange={(e) => updateAllergyItem(idx, e.target.value)}
                  />
                  <Button variant="contained" size="small" className={classes.iconBtnAdd} onClick={addAllergyItem}>
                    <AddIcon fontSize="small" />
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.iconBtnRemove}
                    onClick={() => removeAllergyItem(idx)}
                    disabled={allergyItems.length === 1}
                  >
                    <RemoveIcon fontSize="small" />
                  </Button>
                </Box>
              ))}
            </Box>
          ) : null}
        </FormControl>
      </SectionCard>

      <Paper className={classes.sectionCard} elevation={0}>
        <div className={classes.actionsBar}>
          <Button
            variant="contained"
            disabled={saving}
            onClick={formik.handleSubmit}
            className={classes.primaryBtn}
          >
            {saving ? "Saving…" : isEditMode ? "Save Changes" : "Save Profile"}
          </Button>
          <Button
            variant="outlined"
            onClick={() => props.history.goBack()}
            disabled={saving}
            className={classes.secondaryBtn}
          >
            Cancel
          </Button>
        </div>
      </Paper>
    </div>
  );
}
